export default __webpack_public_path__ + "static/l1-495beeb9d70289cc327e435b271c505e.png";